import React from 'react';
import { Placeholder } from 'rsuite';
import styled from 'styled-components';
import { SkeletonBlock } from './generic-skeleton-placeholders';

const NUM_LISTINGS_AS_ROWS = 40;
const NUM_CATEGORIES_AS_COLUMNS = 20;
const GRID_HEADER_HEIGHT = 62;

const ListSkeletonWrapper = styled.div`
  .rs-placeholder-graph {
    border-radius: 10px 10px 0px 0px;
  }
`;

export function ListSkeleton({ className }) {
  return (
    <ListSkeletonWrapper className={className}>
      <SkeletonBlock height={GRID_HEADER_HEIGHT} />
      <Placeholder.Grid
        rows={NUM_LISTINGS_AS_ROWS}
        columns={NUM_CATEGORIES_AS_COLUMNS}
      />
    </ListSkeletonWrapper>
  );
}
